// Holds the authenticated user's id for plain (non-React) modules that build
// localStorage keys — characterState, characterAuthoringStore, loadBlueprint,
// ConvorcherClient. Those modules can't read React context, so AuthContext sets
// this once the moment the session resolves (before any auth-gated content
// renders). See ENG-559: keys are namespaced by user id so two users on one
// browser don't clobber each other's drafts / session.

let _userId = null

// Set (or clear, with null/'') the current user id. Mirrors to
// window.__USER_ID__ so e2e tests and the console can see who's scoped.
export function setCurrentUserId(id) {
  _userId = id || null
  if (typeof window !== 'undefined') {
    window.__USER_ID__ = _userId
  }
}

export function getCurrentUserId() {
  return _userId
}

// Suffix a base localStorage key with the current user id. Falls back to 'anon'
// when no id is set — a missing-id bug then surfaces as obvious `…-anon` keys
// rather than silently colliding global keys. Post-auth the id is always set
// (ProtectedRoute gates all rendering on the session), so 'anon' should never
// appear in normal operation.
export function scopeKey(base) {
  return `${base}-${_userId ?? 'anon'}`
}
